<template>
    <div>
        <Modal v-model="addEditModal" :title="!labelCorrectionForm.id ? $t('tag.labelCorrection.addLabelCorrection') : $t('tag.labelCorrection.editLabelCorrection')" :loading="loading" :mask-closable="false" width="900px" :styles="{top:'65px'}" @on-cancel="cancel('labelCorrectionForm')" @on-ok="submit('labelCorrectionForm')" :okText="!labelCorrectionForm.id ? $t('alarms.common.add'):$t('alarms.common.edit')">
            <Form ref="labelCorrectionForm" :model="labelCorrectionForm" :label-width="100" :rules="ruleValidate">
                <Row :gutter="12">
                    <Col span="10">
                        <!-- 标准标签key -->
                        <FormItem :label="$t('tag.labelCorrection.standardTagKey')" prop="standardTagKeyId">
                            <Select v-model="labelCorrectionForm.standardTagKeyId" filterable :transfer="true" placeholder="" @on-change="changeStandardTagKeyId">
                                <Option :value="item.id" v-for="item in standardTagKeyIdList" :key="item.id">{{ item.keyName }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="10">
                        <!-- 标准标签value -->
                        <FormItem :label="$t('tag.labelCorrection.standardTagValue')" prop="standardTagValue" >
                            <Input v-model="labelCorrectionForm.standardTagValue" placeholder=""></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns" :loading="modal_loading" :data="standardTagKeyValueRelationData" :height="400" @on-selection-change="getSelection"></Table>
            </Form>
        </Modal>
    </div>
</template>
<script>
    import {getCookie} from '../../../../../utils/cookieUtil.js';
    export default {
        inject: ['reload'],
        data() {
            var validateStandardTagKeyId = (rule, value, callback) => {
                if(this.labelCorrectionForm.standardTagValue){
                    this.$refs.labelCorrectionForm.validateField('standardTagValue');
                }
                callback();
            };
            var validateStandardTagValue = (rule, value, callback) => {
                if(this.labelCorrectionForm.standardTagKeyId){
                    var self = this;
                    self.$api.correctStandardTagValueConfiguration.duplicatesVerify({
                        "id": parseInt(this.labelCorrectionForm.id),
                        "standardTagKeyId": this.labelCorrectionForm.standardTagKeyId,
                        "standardTagValue": this.labelCorrectionForm.standardTagValue
                    })
                    .then(res => {
                        if (res.status == 200) {
                            callback();
                        }
                    })
                    .catch(err => {
                        if (err.status == 400) {
                            callback(new Error(this.$t('tag.labelCorrection.duplicateCorrectionData')));
                        }
                    })
                }else{
                    callback();
                }
            };
            return {
                company:getCookie(global.companyId),
                loading: true,
                addEditModal: false,
                modal_loading:false,
                selection: [],
                standardTagKeyIdList:[],
                labelCorrectionForm: {
                    standardTagKeyId: '',
                    standardTagValue: ''
                },
                ruleValidate: {
                    standardTagKeyId: [
                        {required: true, message: this.$t('tag.labelCorrection.pleaseSelectStandardTagKey'), trigger: 'change', type: 'number'},
                        {validator: validateStandardTagKeyId, trigger: 'change', type: 'number'}
                    ],
                    standardTagValue: [
                        {required: true, message: this.$t('tag.labelCorrection.pleaseInputStandardTagValue'), trigger: 'blur'},
                        {validator: validateStandardTagValue, trigger: 'blur'}
                    ]
                },
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('tag.labelCorrection.originalTag'),
                        key: "standardTagKeyRelationValue",
                        render:(h,params)=>{
                            return h("div",{
                                domProps:{
                                    innerHTML:params.row.standardTagKeyRelationValue
                                }
                            })
                         }
                    }
                ],
                standardTagKeyValueRelationData: [],
                newStandardTagKeyValueRelationList:[]
            }
        },
        methods: {
            init: function (id,row) {
                this.labelCorrectionForm.id = id || '';
                // 标准标签key
                this.getStandardTagListByCompanyId();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['labelCorrectionForm'].resetFields();
                    if (this.labelCorrectionForm.id) {
                        // 标准标签key
                        this.labelCorrectionForm.standardTagKeyId = row.standardTagKeyId;
                        // 标准标签value
                        this.labelCorrectionForm.standardTagValue = row.standardTagValue;
                        // 关联标签
                        this.compareStandardTagKeyValueRelationList= row.standardTagKeyValueRelations;
                        this.$api.correctStandardTagValueConfiguration.listStandardTagKeyValueRelationByStandardTagKeyId({
                            "companyId":row.companyId,
                            "standardTagKeyId":row.standardTagKeyId
                        })
                        .then(res => {
                            this.standardTagKeyValueRelationData = res.data;
                            for (var i = 0; i < this.standardTagKeyValueRelationData.length; i++) {
                                if(this.compareStandardTagKeyValueRelationList!=undefined){
                                    for (var j = 0; j < this.compareStandardTagKeyValueRelationList.length; j++) {
                                        if (this.standardTagKeyValueRelationData[i].id == this.compareStandardTagKeyValueRelationList[j].id) {
                                            this.standardTagKeyValueRelationData[i]._checked = true;
                                        }
                                    }
                                }
                            }
                        })
                    }
                })
                this.addEditModal = true;
            },
            // 标准标签key
            getStandardTagListByCompanyId: function () {
                this.$api.correctStandardTagValueConfiguration.getStandardTagListByCompanyId("companyId",(this.$parent.companyId == null || this.$parent.companyId == '' || this.$parent.companyId == undefined) ? this.company : this.$parent.companyId)
                .then(res => {
                    this.standardTagKeyIdList = res.data;
                })
            },
            // 切换标准标签key
            changeStandardTagKeyId:function(){
                this.modal_loading = true;
                this.$api.correctStandardTagValueConfiguration.listStandardTagKeyValueRelationByStandardTagKeyId({
                    "companyId":(this.$parent.companyId == null || this.$parent.companyId == '' || this.$parent.companyId == undefined) ? this.company : this.$parent.companyId,
                    "standardTagKeyId":this.labelCorrectionForm.standardTagKeyId
                })
                .then(res => {
                    this.standardTagKeyValueRelationData = res.data;
                    this.modal_loading = false;
                })
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newStandardTagKeyValueRelationList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    this.newStandardTagKeyValueRelationList.push(this.selection[i].id);
                }
            },
            // 创建
            /**********************************************************************************/
            submit: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        let labelCorrectionDTO = {
                            "companyId":(this.$parent.companyId == null || this.$parent.companyId == '' || this.$parent.companyId == undefined) ? this.company : this.$parent.companyId,
                            "standardTagKeyId": this.labelCorrectionForm.standardTagKeyId,
                            "standardTagValue": this.labelCorrectionForm.standardTagValue,
                            "standardTagKeyValueRelationIds":this.newStandardTagKeyValueRelationList
                        };
                        if (this.labelCorrectionForm.id > 0) {
                            labelCorrectionDTO.id = this.labelCorrectionForm.id;
                            // 编辑
                            this.$api.correctStandardTagValueConfiguration.update(labelCorrectionDTO)
                            .then(res => {
                                setTimeout(() => {
                                    eventBus.$emit("getDataLabelCorrection");
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.editSuccess'));
                                    this.addEditModal = false;
                                }, 1000);
                            })
                        } else {
                            // 添加
                            this.$api.correctStandardTagValueConfiguration.create(labelCorrectionDTO)
                            .then(res => {
                                setTimeout(() => {
                                    eventBus.$emit("getDataLabelCorrection");
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.addSuccess'));
                                    this.addEditModal = false;
                                }, 1000);
                            })
                        }
                    } else {
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.labelCorrectionForm.id > 0) {
                            this.$Message.error(this.$t('common.editFail'));
                        } else {
                            this.$Message.error(this.$t('common.addFail'));
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.addEditModal = false;
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/label_correction/AddOrUpdateLabelCorrection.vue